module.exports = __webpack_public_path__ + "img/con1_logo.4fa34d63.png";